// extracted by mini-css-extract-plugin
export var discard = "_2r-3";
export var muiTooltipTooltip = "_2r-5";
export var notificationBar = "_2r-2";
export var saveButtonHoverSlotWrapper = "_2r-4";
export var show = "_2r-1";
export var spacer = "_2r-0";